import { useExploreSubjectUnit } from "@twinkltech/curriculum-architect-domain-hooks";
import { useParams } from "react-router-dom";

import { ExploreScheme } from "./ExploreScheme";

export const ExploreSchemeContainer = () => {
  const { subject_id } = useParams();

  if (!subject_id) {
    throw new Error("subject_id is required");
  }

  const { data, error, isLoading } = useExploreSubjectUnit({
    subjectId: subject_id,
  });

  return (
    <ExploreScheme error={error} exploreScheme={data} isLoading={isLoading} />
  );
};
